export default {
  typography: {
    fontFamily: 'Lato, Helvetica, Arial, sans-serif'
  }
};
